<template>
    <!--    机构试题分析-->
    <div>
        <el-row type="flex" align="middle">
            <h2 style="text-align: center; flex: 1">机构试题分析</h2>
            <el-button type="primary" size="small"
                       @click.stop="handleDownload"
                       style="height: 32px" icon="el-icon-download">下载报告</el-button>
        </el-row>
        <div style="text-align: center" class="font-size16">
            机构试题总量
            <span class="c-0C95FD font-weight font-size22">{{allStat.TotalQty}}</span> 道，
            参与组卷试题
            <span class="c-0C95FD font-weight font-size22">{{allStat.TotalJoinExamPaperQty}}</span> 道，
            当年新增试题
            <span class="c-0C95FD font-weight font-size22">{{allStat.YearAddQty}}</span> 道，
            当年参与组卷试题
            <span class="c-0C95FD font-weight font-size22">{{allStat.YearJoinExamPaperQty}}</span> 道
        </div>
        <div class="container">
            <filter-menu v-model="currentSelect"
                         title="总题量分析："
                         label-key="Name"
                         value-key="Id"
                         :menu="menu"/>
            <zj-progress :percentage="getPercent"
                         :stroke-width="34"
                         text-inside
                         :format="(val) => '试题总题数' + stat.TotalQty + '道'"
                         style="margin-top: 20px"
                         :show-text="false"
                         border-radius="2px"
                         stroke-linecap="butt"
                         define-back-color="#F68631"
                         text-color="#FFFFFF"
                         :define-text="'参与组卷试题总题数' + stat.TotalJoinExamPaperQty + '道'"
                         color="#6699FF"/>
            <div class="xy-between font-medium" style="font-size: 14px; margin-top: 10px">
                <div style="color: #6699FF">{{'试题总题数' + stat.TotalQty + '道'}}</div>
                <div style="color: #F68631">{{'参与组卷试题总题数' + stat.TotalJoinExamPaperQty + '道'}}</div>
            </div>
            <zj-progress :percentage="getYearPercent"
                         :stroke-width="34"
                         text-inside
                         :format="(val) => '当年新增试题总题数' + stat.YearAddQty + '道'"
                         style="margin-top: 20px"
                         border-radius="2px"
                         stroke-linecap="butt"
                         define-back-color="#47CEA4"
                         :show-text="false"
                         text-color="#FFFFFF"
                         :define-text="'当年参与组卷试题总题数' + stat.YearJoinExamPaperQty + '道'"
                         color="#F7AF3F"/>
            <div class="xy-between font-medium" style="font-size: 14px; margin-top: 10px">
                <div style="color: #F7AF3F">{{'当年新增试题总题数' + stat.YearAddQty + '道'}}</div>
                <div style="color: #47CEA4">{{'当年参与组卷试题总题数' + stat.YearJoinExamPaperQty + '道'}}</div>
            </div>
            <div style="margin-top: 30px">
                <div class="font-size18 font-medium">试题年份分析</div>
                <bar-chart :chart-data="stat.YearQties"
                           height="300px"
                           :options="groupOptions"
                           :dimensions="['Year', 'Qty', 'JoinExamPaperQty']"/>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultSeriesSettings as barSettings } from "@/components/Charts/BarChart/config";
import { defaultSeriesSettings as lineSettings } from "@/components/Charts/LineChart/config";
import FilterMenu from "./FilterMenu";
import { exportSubjectReport, getStatSubjectReport } from "@/api/manage"
import { downloadUrl } from "download.js";
import { isEmpty } from "lodash";

export default {
    name: "GroupQuestionAnalyse",
    components: { FilterMenu },
    data() {
        return {
            currentSelect: -1,
            menu: [],
            stat: {},
            allStat: {}
        }
    },
    watch: {
        currentSelect () {
            this.getStatSubjectReport()
        }
    },
    computed: {
        getSeries() {
            return [
                Object.merge(barSettings(), {
                    name: "全部试题年代分布",
                    color: "#6699FF",
                    areaStyle: undefined,
                    label: {
                        fontSize: 14,
                        formatter: ["{Qty|{@Qty}}", "{JoinExamPaperQty|{@JoinExamPaperQty}道}"].join("/"),
                        rich: {
                            JoinExamPaperQty: {
                                color: "#F7B44C",
                                fontSize: 14,
                            }
                        }
                    }
                }),
                Object.assign(lineSettings(), {
                    name: "当年参与组卷年代分布",
                    color: "#F7B44C",
                    areaStyle: undefined
                })]
        },
        groupOptions ({ getSeries }) {
            return {
                series: getSeries,
                yAxis: [
                    {
                        type: "value",
                        minInterval: 1,
                        axisLabel: {
                            fontSize: 14
                        }
                    }
                ],
                title: {
                    text: ""
                },
            }
        },
        getPercent () {
            const { TotalJoinExamPaperQty = 0, TotalQty = 0 } = this.stat
            const total = TotalJoinExamPaperQty + TotalQty
            return total === 0 ? 0 : parseFloat(((TotalQty / total) * 100).toFixed(2))
        },
        getYearPercent () {
            const { YearAddQty = 0, YearJoinExamPaperQty = 0 } = this.stat
            const total = YearAddQty + YearJoinExamPaperQty
            return total === 0 ? 0 : parseFloat(((YearAddQty / total) * 100).toFixed(2))
        }
    },
    created() {
        this.getStatSubjectReport()
    },
    methods: {
        getStatSubjectReport () {
            getStatSubjectReport(this.currentSelect).then(res => {
                if (Array.isArray(res.SubjectTypes) && res.SubjectTypes.length > 0) {
                    this.menu = res.SubjectTypes
                } else {
                    this.menu = []
                }
                delete res.SubjectTypes
                if (this.currentSelect === -1 && isEmpty(this.allStat)) {
                    this.allStat = res
                }
                this.stat = res
            })
        },
        handleDownload () {
            exportSubjectReport().then(res => {
                downloadUrl("机构试题分析", res)
            })
        }
    }
}
</script>

<style scoped lang="less">
.container {
    margin-top: 40px;
    border: 2px solid #256CF4;
    padding: 30px;
}
</style>
